import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, Message, SelectItem } from 'primeng/api';
import { LazyLoadEvent } from "../../../models/DataTables/lazyLoadEvent";
import { Program, CreateCoachModel, BeneficiaryModel } from "../../../models/inModels/program";
import { ProgramService } from "../../../services/program.service";
import { DataTable } from 'primeng/primeng';
import { UserService } from "../../../services/user/user.service";

@Component({
	selector: 'app-programs',
	templateUrl: './programs.component.html',
	styleUrls: ['./programs.component.css']
})
export class ProgramsComponent {
	items: Program[];
	rows: SelectItem[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];

	selectedProgramId: number;
	createCoachDialog = false;
	createBeneficiaryDialog = false;
	beneficiaryModel: BeneficiaryModel;
	users: SelectItem[];
	selectedUser: SelectItem;
	constructor(
		private service: ProgramService,
		private userService: UserService,
		private router: Router,
		private confirmationService: ConfirmationService) {
		this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
	}

	changeRows(event): void {
		this.load(this.rowEvent);
	}

	reset(dt: DataTable, gb: any) {
		gb.value = '';
		dt.reset();
	}

	load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.service.search(event).then(
			dataPager => {
				this.items = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.items = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	edit(item: Program) {
		this.router.navigate(['programs/edit', item.Id]);
	}


	delete(item: Program) {
		this.confirmationService.confirm({
			message: `Are you sure you want to delete this Program?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.service.delete(item.Id).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}

	showCreateCoach(item: Program) {
		this.selectedProgramId = item.Id;
		this.createCoachDialog = true;
	}

	initUserDropDown(event) {
		this.userService.getDropDown(event).then(
			x => {
				this.users = x;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	createCoach() {
		this.loading = true;
		let model = new CreateCoachModel();
		model.coachId = this.selectedUser.value;
		model.programId = this.selectedProgramId;
		this.service.createCoach(model).then(
			result => {
				this.loading = false;
				this.createCoachDialog = false;
				this.selectedProgramId = null;
				this.selectedUser = null;
				this.load(this.rowEvent);
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	showCreateBeneficiary(item: Program) {
		this.beneficiaryModel = new BeneficiaryModel();
		this.beneficiaryModel.ProgramId = item.Id;
		this.createBeneficiaryDialog = true;
	}

	createBeneficiary() {
		this.loading = true;
		this.beneficiaryModel.UserId = this.selectedUser.value;
		this.service.createBeneficiary(this.beneficiaryModel).then(
			result => {
				this.loading = false;
				this.createBeneficiaryDialog = false;
				this.beneficiaryModel = null;
				this.load(this.rowEvent);
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

}



// WEBPACK FOOTER //
// ./src/app/components/reporting/programs/programs.component.ts